const channels = [
  { icon: "ri-focus-3-line", tone: "bg-primary-100 text-primary-700", name: "频道专区", count: "内容分区直达", desc: "按频道聚合入口，找对应板块更快。" },
  { icon: "ri-fire-line", tone: "bg-accent-100 text-accent-800", name: "关注榜", count: "热度排序", desc: "近期热度靠前的看点，刷新即见最新。" },
  { icon: "ri-history-line", tone: "bg-secondary-200 text-secondary-800", name: "往期回顾", count: "历史归档", desc: "过往内容与旧入口留档，方便回溯查找。" },
  { icon: "ri-notification-3-line", tone: "bg-accent-100 text-accent-800", name: "更新提醒", count: "变动通知", desc: "入口与内容有变动时，这里集中提示。" },
  { icon: "ri-bookmark-3-line", tone: "bg-secondary-200 text-secondary-800", name: "我的收藏", count: "常用地址", desc: "把吃瓜17 常用网址统一存进来随时点。" },
  { icon: "ri-question-line", tone: "bg-primary-100 text-primary-700", name: "访问答疑", count: "常见问题", desc: "入口打不开、切换备用等问题的解答。" },
];

export default function Channels() {
  return (
    <section id="channels" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="max-w-2xl">
            <span className="text-xs font-semibold tracking-widest text-primary-600">· 常用分区</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950">按分区直达，找内容不绕路</h2>
          </div>
          <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
            各分区彼此独立、文案角度不同，配合导航与收藏使用，入口与内容都能快速定位。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {channels.map((c) => (
            <button
              key={c.name}
              type="button"
              className="group text-left flex items-center gap-4 rounded-xl border border-secondary-200/70 bg-background-100/60 p-5 hover:bg-secondary-100 transition-colors"
            >
              <span className={`grid place-items-center w-11 h-11 shrink-0 rounded-lg ${c.tone}`}>
                <i className={`${c.icon} text-xl`} />
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-2">
                  <span className="text-base font-bold text-foreground-950">{c.name}</span>
                  <span className="hidden sm:inline text-[11px] text-foreground-400">{c.count}</span>
                </span>
                <span className="block mt-1 text-xs text-foreground-600 leading-relaxed">{c.desc}</span>
              </span>
              <i className="ri-arrow-right-s-line text-xl text-secondary-400 ml-auto shrink-0 transition-transform group-hover:translate-x-0.5" />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}